// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import categoryListingStyles from "@steiner/App/SharedStyles/CategoryListingStyles";
import { categoryListStyles } from "@steiner/Overrides/Widgets/Category/CategoryList";
import Plus from "@steiner/XDL/Icons/Plus";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { ellipsis } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

categoryListStyles.container = {
    ...categoryListingStyles.container,
};

categoryListStyles.categoryItem = {
    ...categoryListingStyles.rightBorderedCategoryListItem,
};

categoryListStyles.innerContainer = {
    gap: 12,
};

categoryListStyles.categoryImageItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};

categoryListStyles.categoryImage = {
    width: "124px",
    height: "124px",
    css: css`
        img {
            aspect-ratio: 1 / 1;
        }
    `,
};

categoryListStyles.categoryNameLinkItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};

categoryListStyles.categoryNameLink = {
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.semiBold,
        lineHeight: "19px",
        css: css`
            text-align: center;
            ${ellipsis(3)}
        `,
    },
};

categoryListStyles.subCategoryNameLink = {
    typographyProps: {
        size: "12px",
        css: css`
            margin-top: 12px;
            ${ellipsis(3)}
        `,
    },
    css: css`
        display: flex;
        justify-content: center;
    `,
};

categoryListStyles.viewMoreLinkItem = {
    width: 12,
};

categoryListStyles.viewMoreLink = {
    icon: {
        iconProps: {
            size: 12,
            src: Plus,
        },
    },
    typographyProps: {
        size: "12px",
        css: css`
            text-align: center;
        `,
    },
    css: css`
        display: flex;
        justify-content: center;
    `,
};
